import { SxProps } from '@mui/material';

export const DpFanInitialStageFrameSx = (isPage: boolean): SxProps => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	backgroundColor: { xs: '#FFFFFF', md: '#F7F7F7' },
	borderTopLeftRadius: isPage ? '0px' : { xs: '16px', md: '0px' },
	borderTopRightRadius: isPage ? '0px' : { xs: '16px', md: '0px' },
	padding: { xs: '40px 30px', md: '0px' },
	position: 'relative',
	width: '100%',
	height: isPage ? '100%' : { xs: 'auto', md: '100%' },
});

export const DpFanInitialStageContentSx: SxProps = {
	flex: 1,
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	gap: { xs: '27px', md: '30px' },
};

export const DpFanInitialStageDataSx: SxProps = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	maxWidth: { xs: '100%', md: '720px' },
	width: '100%',
};

export const DpFanInitialStageImageSx: SxProps = { marginBottom: { xs: '16px', md: '37px' } };

export const DpFanInitialStageTitleSx: SxProps = {
	color: '#2C2C2C',
	fontSize: { xs: '20px', md: '36px' },
	fontWeight: '800',
	textAlign: 'center',
	marginTop: '15px',
	marginBottom: '10px',
	letterSpacing: '0px',
	lineHeight: 1.2,
};

export const DpFanInitialStageDescSx: SxProps = {
	color: '#2C2C2C',
	fontSize: { xs: '15px', md: '20px' },
	textAlign: 'center',
};

export const DpFanInitialStageButtonsSx: SxProps = {
	display: 'flex',
	gap: '16px',
	width: '100%',
	justifyContent: { xs: undefined, md: 'center' },
};

export const DpFanInitialStageCancelButtonSx: SxProps = {
	maxWidth: { xs: '100%', md: '198px' },
};

export const DpFanInitialStageSubmitButtonSx: SxProps = {
	maxWidth: { xs: '100%', md: '262px' },
};
